import * as yup from 'yup';

import { formatMessage } from 'utils/messages/utils';

export default yup.object().shape({
  newScenarioName: yup.string().trim().min(1).max(64).required().label(formatMessage('SCENARIO_NAME'))
});
